import { render, staticRenderFns } from "./galleryJobsCover.vue?vue&type=template&id=32064198&scoped=true"
import script from "./galleryJobsCover.vue?vue&type=script&lang=js"
export * from "./galleryJobsCover.vue?vue&type=script&lang=js"
import style0 from "./galleryJobsCover.vue?vue&type=style&index=0&id=32064198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32064198",
  null
  
)

export default component.exports